
import { formatDistanceToNow } from 'date-fns';
import { formatTimeTo12Hour } from '@/utils/dateUtils';

export const formatExpenseCurrency = (amount: number, currency: string) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  }).format(amount);
};

export const formatExpenseDate = (dateString: string) => {
  return formatDistanceToNow(new Date(dateString), { addSuffix: true });
};

// Format time to 12-hour format with AM/PM
export const formatExpenseTime = (timeString: string) => {
  return formatTimeTo12Hour(timeString);
};
